import { Link } from 'react-router-dom';
import { renderCommentText } from '../utils/commentUtils';
import styles from './CommentPreview.module.css';

function CommentPreview({ text }) {
  if (!text || !text.trim()) return null;

  const parts = renderCommentText(text);

  return (
    <div className={styles.preview}>
      {parts.map((part, idx) => {
        if (part.type === 'link') {
          return (
            <a
              key={idx}
              href={part.url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.previewLink}
            >
              {part.content}
            </a>
          );
        }
        if (part.type === 'mention') {
          return (
            <Link
              key={idx}
              to={`/hairstylist/${part.id}`}
              className={styles.previewMention}
            >
              @{part.name}
            </Link>
          );
        }
        return <span key={idx}>{part.content}</span>;
      })}
    </div>
  );
}

export default CommentPreview;

